class ForecastHelper {
  setHeader(headers)
    {
        var keys = headers.shift();
        var headers = headers.map(function(row){
            return keys.reduce(function(obj,key,i){
                obj[key] = row[i];
                return obj;
            },{})
        });
        return headers;
    }

    peakHeaders(instance)
    {
        const headers = [
            {
              text: "Name",
              align: "left",
              value: "name",
              sortable: false,
              width: "auto",
              filter: instance.nameFilter,
            },
    
            {
              text: "Abteilung",
              align: "left",
              value: "department",
              sortable: false,
              width: "auto",
              filter: instance.departmentFilter,
            },
            {
              text: "Skill",
              align: "left",
              value: "skill",
              sortable: true,
              width: "auto",
              filter: instance.skillFilter,
            },
            {
              text: "Dim.",
              align: "left",
              sortable: false,
              width: "auto",
            },
           
          ]

          return headers;
    }
    headers1(instance)
    {
     const headers= [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: false,
          width: "auto",
          filter: instance.nameFilter,
        },
    
        {
          text: "Abteilung",
          align: "left",
          value: "department",
          sortable: false,
          width: "auto",
          filter: instance.departmentFilter,
        },
        {
          text: "Skill",
          align: "left",
          value: "skill",
          sortable: true,
          width: "auto",
          filter: instance.skillFilter,
        },
        {
          text: "Dim.",
          align: "left",
          sortable: false,
          width: "auto",
        },
        {
          text: "Januar",
          value: "ist_daten[2]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: "Febreuer",
          value: "ist_daten[3]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: "März  ",
          value: "ist_daten[3]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: "April  ",
          value: "ist_daten[4]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: "Mai   ",
          value: "ist_daten[5]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: "Juni  ",
          value: "ist_daten[6]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: "Juli  ",
          value: "ist_daten[7]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: "August",
          value: "ist_daten[8]",
          align: "left",
          sortable: false,
          class:"deep-orange--text"
        },
        {
          text: "September",
          value: "ist_daten[9]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: "Oktober",
          value: "ist_daten[10]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: "November",
          value: "ist_daten[12]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: "Dezember",
          value: "ist_daten[13]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text text-lg-subtitle-2"
        },
        {
          text: "Sum",
          align: "left",
          sortable: true,
          width: "auto",
        },
      ]
      return headers;
    }
    headers2(instance)
    {
      let arr = [];
        let temp = new Date().getMonth()+1;
        let year = new Date().getFullYear();
      for (let i=1;i<=12;i++){
        let x = year.toString().concat("-");
        arr.push(x.concat(temp.toString()));
        temp++;
          if(temp==13){
          temp=1;
          year = new Date().getFullYear()+1;
        }        
      }

      const m=arr;
      let headers2 = [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: false,
          width: "auto",
          filter: instance.nameFilter,
        },

        {
          text: "Abteilung",
          align: "left",
          value: "department",
          sortable: false,
          width: "auto",
          filter: instance.departmentFilter,
        },
        {
          text: "Skill",
          align: "left",
          value: "skill",
          sortable: true,
          width: "auto",
          filter: instance.skillFilter,
        },
        {
          text: "Dim.",
          align: "left",
          sortable: false,
          width: "auto",
        },
           {
          text: `${m[0]}`,
          value: "ist_daten[2]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: `${m[1]}`,
          value: "ist_daten[2]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: `${m[2]}`,
          value: "ist_daten[3]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: `${m[3]}`,
          value: "ist_daten[3]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: `${m[4]}`,
          value: "ist_daten[4]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: `${m[5]}`,
          value: "ist_daten[5]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: `${m[6]}`,
          value: "ist_daten[6]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: `${m[7]}`,
          value: "ist_daten[7]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: `${m[8]}`,
          value: "ist_daten[8]",
          align: "left",
          sortable: false,
          class:"deep-orange--text"
        },
        {
          text: `${m[9]}`,
          value: "ist_daten[9]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: `${m[10]}`,
          value: "ist_daten[10]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: `${m[11]}`,
          value: "ist_daten[12]",
          align: "left",
          sortable: false,
          width: "auto",
          class:"deep-orange--text"
        },
        {
          text: "Sum",
          align: "left",
          sortable: true,
          width: "auto",
        },
      ];
      return headers2;
    }

   
}

export default ForecastHelper = new ForecastHelper();